import { render, staticRenderFns } from "./FamilyCreateUpdate.vue?vue&type=template&id=0fc6d12e&scoped=true&"
import script from "./FamilyCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./FamilyCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./FamilyCreateUpdate.vue?vue&type=style&index=0&id=0fc6d12e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc6d12e",
  null
  
)

export default component.exports